import {
    AppBar,
    Box,
    CardMedia,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Stack,
    Theme
} from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { LoadingButton } from '@mui/lab';
import { logout } from '../redux-store/actions/auth';
import { CustomInvestorLayout, Footer } from '../components/commonComponents';

export const NotAuthorized = (): JSX.Element => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onClick = async () => {
        try {
            setLoading(true);
            await dispatch(logout());
            history.replace('/login');
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Stack
            sx={{
                minHeight: '100vh',
                background: '#f2f6f8 url("/images/abcl-newbg.svg")',
                backgroundSize: 'cover',
            }}
        >

            <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent' }}>
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <Box>
                        <CardMedia
                            component="img"
                            // onClick={() => history.push('/')}
                            src="/images/abcl-wealth-logo.svg"
                            alt="Logo"
                            sx={{
                                margin: "15px 0px 0px 15px",
                                cursor: 'pointer',
                                width: '12rem',
                            }}
                        />
                    </Box>
                </Box>
            </AppBar>
            <Box sx={{ height: '90vh', width: '100%' }}>

            </Box>
            <Dialog
                open={true}
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        minWidth: { sx: '300px', md: '400px' },
                        maxWidth: { sx: '500px', md: '500px' },
                        borderRadius: '8px',
                        padding: '30px 30px 20px',
                        textAlign: 'center',
                        color: theme.palette.grey[50],
                    },
                    '& .MuiDialogContent-root': {
                        textAlign: 'center',
                    },
                    '& .MuiDialogActions-root': {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',

                        '& .MuiButton-root': {
                            width: '160px',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            px: '18px',
                            py: 1,
                            margin: 'auto',
                            marginBottom: '20px',
                        },
                    },
                })}>
                <DialogContent>
                    <DialogContentText>Permissions are missing for this user role. Kindly contact administrator.</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loadingPosition="start"
                        type="submit"
                        loading={loading}
                        variant="contained"
                        fullWidth={true}
                        onClick={onClick}>
                        Logout
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            <Footer />
        </Stack>
    );
};
